// Profile Plan Information Modal
export const PLAN_INFORMATION = 'planInformation';
export const UPDATE_YOUR_PLAN = 'updateYourPlan';
export const PAYMENT_METHODS = 'paymentMethods';
export const ADD_PAYMENT = 'addPayment';
